import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { SeitenLadeanzeige } from './components/SeitenLadeanzeige';
import LoginPage from './pages/Auth/LoginPage';
import MfaPage from './pages/Auth/MfaPage';
import RegisterPage from './pages/Auth/RegisterPage';
import EmailBestaetigenPage from './pages/Auth/EmailBestaetigenPage';
import PasswortVergessenPage from './pages/Auth/PasswortVergessenPage';
import PasswortZuruecksetzenPage from './pages/Auth/PasswortZuruecksetzenPage';
import ProfilPage from './pages/ProfilPage';
const MandantPage = lazy(() => import('./pages/SettingsPages/MandantPage'));
const RollenPage = lazy(() => import('./pages/SettingsPages/RollenPage'));
const MitarbeiterPage = lazy(() => import('./pages/SettingsPages/MitarbeiterPage'));
const AblagePage = lazy(() => import('./pages/SettingsPages/AblagePage'));
import EinladungPage from './pages/Auth/EinladungPage';
const OnboardingWizardPage = lazy(() => import('./pages/OnboardingWizardPage'));
import Layout from './components/Layout';
import { SeitenFehlergrenze } from './components/Fehlergrenze';
import Dashboard from './pages/Dashboard';
import Einstellungen from './pages/Einstellungen';
const CompanySettingsPage = lazy(() => import('./pages/SettingsPages/CompanySettingsPage'));
const CustomerSettingsPage = lazy(() => import('./pages/SettingsPages/CustomerSettingsPage'));
const LocationSettingsPage = lazy(() => import('./pages/SettingsPages/LocationSettingsPage'));
const BuildingSettingsPage = lazy(() => import('./pages/SettingsPages/BuildingSettingsPage'));
const FloorSettingsPage = lazy(() => import('./pages/SettingsPages/FloorSettingsPage'));
const CatalogSettingsPage = lazy(() => import('./pages/SettingsPages/CatalogSettingsPage'));
import Erfassung from './pages/Erfassung';
import Uebersicht from './pages/Uebersicht';
const Berichte = lazy(() => import('./pages/Berichte'));
const Auswertung = lazy(() => import('./pages/Auswertung'));
const ProduktkatalogPage = lazy(() => import('./pages/ProduktkatalogPage'));
const MassGrenzwertePage = lazy(() => import('./pages/MassGrenzwertePage'));
const WissensdatenbankPage = lazy(() => import('./pages/WissensdatenbankPage'));
const PruefbereichePage = lazy(() => import('./pages/PruefbereichePage'));
const ProjektePage = lazy(() => import('./pages/ProjektePage'));
import MaengelPage from './pages/MaengelPage';
const ArbeitsauftraegePage = lazy(() => import('./pages/ArbeitsauftraegePage'));
const GutachtenPage = lazy(() => import('./pages/GutachtenPage'));
const AngebotePage = lazy(() => import('./pages/AngebotePage'));
const RechnungenPage = lazy(() => import('./pages/RechnungenPage'));
const NummernkreisePage = lazy(() => import('./pages/NummernkreisePage'));
const FreischaltungenPage = lazy(() => import('./pages/FreischaltungenPage'));
const FaelligkeitenPage = lazy(() => import('./pages/FaelligkeitenPage'));
const WartungenPage = lazy(() => import('./pages/WartungenPage'));
const WartungsvorlagenPage = lazy(() => import('./pages/WartungsvorlagenPage'));
const ImportExport = lazy(() => import('./pages/ImportExport'));
const BackupRestore = lazy(() => import('./pages/BackupRestore'));
const PlattformPage = lazy(() => import('./pages/PlattformPage'));
const KiSettingsPage = lazy(() => import('./pages/SettingsPages/KiSettingsPage'));
const SyncKonfliktePage = lazy(() => import('./pages/SyncKonfliktePage'));
const GuidedInspectionWizard = lazy(() => import('./pages/GuidedInspectionWizard'));
const QRScanPage = lazy(() => import('./pages/QRScanPage'));
const ZeiterfassungPage = lazy(() => import('./pages/ZeiterfassungPage'));
const PlanverortungPage = lazy(() => import('./pages/PlanverortungPage'));
const GrundrissEditorPage = lazy(() => import('./pages/GrundrissEditorPage'));

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Ohne Anmeldung erreichbar -- ausserhalb von Layout, weil die
              Navigation ohne angemeldeten Benutzer nichts anzuzeigen hat. */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/mfa" element={<MfaPage />} />
          <Route path="/registrieren" element={<RegisterPage />} />
          <Route path="/email-bestaetigen" element={<EmailBestaetigenPage />} />
          <Route path="/passwort-vergessen" element={<PasswortVergessenPage />} />
          <Route path="/passwort-zuruecksetzen" element={<PasswortZuruecksetzenPage />} />
          <Route path="/einladung/:token" element={<EinladungPage />} />

          {/* Der Ersteinrichtungs-Assistent liegt bewusst AUSSERHALB von
              `Layout` -- kein Sidebar-Rauschen waehrend der Einrichtung --
              verlangt aber eine Anmeldung wie jede andere geschuetzte
              Seite. Kein Zwang: `ProtectedRoute` leitet nur bei fehlender
              Anmeldung um, die Seite selbst blockiert keine andere Route. */}
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <Suspense fallback={<SeitenLadeanzeige />}>
                  <OnboardingWizardPage />
                </Suspense>
              </ProtectedRoute>
            }
          />

          {/* Alles Uebrige nur angemeldet. Ein Stern-Pfad statt einer Huelle
              je Route: so ist eine spaeter ergaenzte Seite automatisch
              geschuetzt und nicht erst, wenn jemand daran denkt. */}
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <Layout>
                  <SeitenFehlergrenze>
                  <Suspense fallback={<SeitenLadeanzeige />}>
                  <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/einstellungen" element={<Einstellungen />} />
                    <Route path="/profil" element={<ProfilPage />} />
                    <Route path="/einstellungen/mandant" element={<MandantPage />} />
                    <Route
                      path="/einstellungen/rollen"
                      element={
                        <ProtectedRoute erfordert="rollen.lesen">
                          <RollenPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/einstellungen/mitarbeiter"
                      element={
                        <ProtectedRoute erfordert="benutzer.lesen">
                          <MitarbeiterPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/einstellungen/ablage"
                      element={
                        <ProtectedRoute erfordert="ablage.lesen">
                          <AblagePage />
                        </ProtectedRoute>
                      }
                    />
              <Route path="/einstellungen/allgemeines" element={<CompanySettingsPage />} />
              <Route path="/einstellungen/kunden" element={<CustomerSettingsPage />} />
              <Route path="/einstellungen/standorte" element={<LocationSettingsPage />} />
              <Route path="/einstellungen/gebaeude" element={<BuildingSettingsPage />} />
              <Route path="/einstellungen/stockwerke" element={<FloorSettingsPage />} />
              <Route path="/einstellungen/katalog" element={<CatalogSettingsPage />} />
              <Route path="/erfassung" element={<Erfassung />} />
              <Route path="/uebersicht" element={<Uebersicht />} />
              <Route path="/berichte" element={<Berichte />} />
              <Route path="/auswertung" element={<Auswertung />} />

              {/* System-Einstellungen (Import/Export, Backup) */}
              <Route path="/einstellungen/import-export" element={<ImportExport />} />
              <Route path="/einstellungen/backup" element={<BackupRestore />} />
              <Route path="/plattform" element={<PlattformPage />} />
              <Route path="/einstellungen/ki" element={<KiSettingsPage />} />
              {/* Buero-Admin-Uebersicht ueber offene Sync-Konflikte der
                  mobilen App (PLAN_MOBILE_APP.md M.8) -- serverseitig
                  ohnehin an `system.sync_konflikte_verwalten` gebunden
                  (mobileSyncController.konflikteListe), hier zusaetzlich
                  vor dem Rendern geprueft, damit ein Klick nicht erst in
                  einer 403-Fehlermeldung endet. */}
              <Route
                path="/einstellungen/sync-konflikte"
                element={
                  <ProtectedRoute erfordert="system.sync_konflikte_verwalten">
                    <SyncKonfliktePage />
                  </ProtectedRoute>
                }
              />

              {/* Neue Seiten (V2) */}
              <Route path="/produktkatalog" element={<ProduktkatalogPage />} />

              {/* Prüfbereiche sind fachlich ein Katalog wie die Normen --
                  daher dasselbe Recht wie Produktkatalog und Normungen. */}
              <Route
                path="/pruefbereiche"
                element={
                  <ProtectedRoute erfordert="kataloge.lesen">
                    <PruefbereichePage />
                  </ProtectedRoute>
                }
              />
              {/* Maßgrenzwerte gehören zu den Katalogen: sie sind
                  Normwerte, die ein Fachkundiger pflegt -- wer Fotos
                  annotieren darf, darf messen, aber nicht festlegen, ab
                  wann ein Maß zu groß ist. */}
              <Route
                path="/mass-grenzwerte"
                element={
                  <ProtectedRoute erfordert="kataloge.lesen">
                    <MassGrenzwertePage />
                  </ProtectedRoute>
                }
              />
              {/* Die Wissensdatenbank steht bei den Katalogen, hat aber
                  ein eigenes Recht: ihre Artikel tragen eine
                  Sichtbarkeitsstufe. WELCHE Artikel jemand sieht, hängt
                  zusätzlich an `sichtbarkeit.intern_lesen` — das erledigt
                  der Query-Proxy, nicht diese Route. */}
              <Route
                path="/wissen"
                element={
                  <ProtectedRoute erfordert="wissen.lesen">
                    <WissensdatenbankPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/projekte" element={<ProjektePage />} />
              <Route path="/maengel" element={<MaengelPage />} />
              <Route path="/arbeitsauftraege" element={<ArbeitsauftraegePage />} />

              {/* Gutachten: Liste und Editor teilen sich die Seite. Die
                  Kennung steht im Pfad, damit ein Gutachten verlinkbar
                  ist -- das ist der Normalfall, wenn jemand einen
                  Kollegen um die Prüfung bittet. */}
              <Route
                path="/gutachten"
                element={
                  <ProtectedRoute erfordert="gutachten.lesen">
                    <GutachtenPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/gutachten/:id"
                element={
                  <ProtectedRoute erfordert="gutachten.lesen">
                    <GutachtenPage />
                  </ProtectedRoute>
                }
              />
              {/* Faktura: Liste und Beleg teilen sich die Seite, damit
                  ein Angebot oder eine Rechnung verlinkbar ist. Das
                  Leserecht genügt für den Einstieg -- die schärferen
                  Rechte (finalisieren, stornieren, DATEV) prüft der
                  Server an der jeweiligen Route, und die Oberfläche
                  blendet die zugehörigen Knöpfe aus. */}
              <Route
                path="/angebote"
                element={
                  <ProtectedRoute erfordert="faktura.lesen">
                    <AngebotePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/angebote/:id"
                element={
                  <ProtectedRoute erfordert="faktura.lesen">
                    <AngebotePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rechnungen"
                element={
                  <ProtectedRoute erfordert="faktura.lesen">
                    <RechnungenPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rechnungen/:id"
                element={
                  <ProtectedRoute erfordert="faktura.lesen">
                    <RechnungenPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/nummernkreise"
                element={
                  <ProtectedRoute erfordert="faktura.lesen">
                    <NummernkreisePage />
                  </ProtectedRoute>
                }
              />
              {/*
                * Ohne erfordert: die Seite zeigt jedem seinen EIGENEN
                * Zugriff, und dafür gibt es bewusst kein Recht. Wer nicht
                * sehen kann, worauf er freigeschaltet ist, hält eine leere
                * Liste für einen Fehler. Die Gesamtliste innerhalb der
                * Seite hängt an `zuweisungen.lesen`.
                */}
              <Route path="/freischaltungen" element={<FreischaltungenPage />} />

              <Route path="/faelligkeiten" element={<FaelligkeitenPage />} />
              <Route path="/wartungen" element={<WartungenPage />} />

              {/* Die Vorlagen sind der Ursprung jeder geplanten Wartung.
                  Leserecht genuegt fuer den Einstieg -- Anlegen und
                  Aendern pruefen wartung.anlegen bzw. wartung.bearbeiten,
                  und die Oberflaeche blendet die Knoepfe entsprechend aus. */}
              <Route
                path="/wartungsvorlagen"
                element={
                  <ProtectedRoute erfordert="wartung.lesen">
                    <WartungsvorlagenPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/zeiterfassung" element={<ZeiterfassungPage />} />
              <Route path="/planverortung" element={<PlanverortungPage />} />
              <Route path="/grundriss-editor" element={<GrundrissEditorPage />} />

              {/* Guided Inspection Wizard (V4) */}
              <Route path="/wizard/:projektId" element={<GuidedInspectionWizard />} />

              {/* QR Code Deep Link (V3) */}
              <Route path="/e/:code" element={<QRScanPage />} />
        
                  </Routes>
                  </Suspense>
                  </SeitenFehlergrenze>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
